import { METHOD_TYPES } from 'utils/constants/index'
import axiosInstanceService from 'network/apis/index'
import { microServices } from 'network/apis/microservice/index'

export const getLimboGameBetHistory = (params) => {
  return axiosInstanceService(METHOD_TYPES.get, '/fast-games/limbo-game/my-bets', {}, {
    server: microServices.SERVICE_URL_1,
    params
  })
}

export const limboGamePlaceBet = ({ data }) => {
  return axiosInstanceService(METHOD_TYPES.post, '/fast-games/limbo-game/place-bet', data, {
    server: microServices.SERVICE_URL_1
  })
}
